module.exports = __webpack_public_path__ + "static/media/12_l_muhomor_5.94_88.43.fbffb1ff.png";